import React, { useCallback, useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ShoppingBag } from 'lucide-react';
const BUYERS = [{
  name: 'Sarah K.',
  location: 'California',
  time: '2 min ago'
}, {
  name: 'Emily W.',
  location: 'Ontario',
  time: '4 min ago'
}, {
  name: 'Jessica M.',
  location: 'Texas',
  time: '5 min ago'
}, {
  name: 'Lauren T.',
  location: 'British Columbia',
  time: '7 min ago'
}, {
  name: 'Rachel B.',
  location: 'New York',
  time: '8 min ago'
}, {
  name: 'Megan H.',
  location: 'Alberta',
  time: '11 min ago'
}, {
  name: 'Ashley P.',
  location: 'Florida',
  time: '12 min ago'
}, {
  name: 'Stephanie R.',
  location: 'Quebec',
  time: '14 min ago'
}, {
  name: 'Amanda C.',
  location: 'Illinois',
  time: '16 min ago'
}, {
  name: 'Brittany L.',
  location: 'Manitoba',
  time: '18 min ago'
}, {
  name: 'Diana V.',
  location: 'Georgia',
  time: '20 min ago'
}, {
  name: 'Natalie F.',
  location: 'Nova Scotia',
  time: '22 min ago'
}];
export function SocialProofToast() {
  const [visible, setVisible] = useState(false);
  const [currentIndex, setCurrentIndex] = useState(0);
  const showNext = useCallback(() => {
    setCurrentIndex(prev => (prev + 1) % BUYERS.length);
    setVisible(true);
    // Hide after 4 seconds
    setTimeout(() => {
      setVisible(false);
    }, 4000);
  }, []);
  useEffect(() => {
    // First appearance after 15 seconds
    const initialTimer = setTimeout(() => {
      showNext();
    }, 15000);
    return () => clearTimeout(initialTimer);
  }, [showNext]);
  useEffect(() => {
    if (!visible) {
      // Show next one 18-30 seconds after hiding
      const delay = 18000 + Math.random() * 12000;
      const timer = setTimeout(() => {
        showNext();
      }, delay);
      return () => clearTimeout(timer);
    }
  }, [visible, showNext]);
  const buyer = BUYERS[currentIndex];
  return <AnimatePresence data-id="element-555">
      {visible && <motion.div initial={{
      opacity: 0,
      y: 20,
      scale: 0.95
    }} animate={{
      opacity: 1,
      y: 0,
      scale: 1
    }} exit={{
      opacity: 0,
      y: 10,
      scale: 0.95
    }} transition={{
      duration: 0.5,
      ease: [0.25, 0.1, 0.25, 1]
    }} className="fixed bottom-20 md:bottom-6 left-4 md:left-6 z-40 max-w-[280px]" data-id="element-556">
          <div className="flex items-center gap-3 px-4 py-3 rounded-2xl backdrop-blur-md" style={{
        background: 'rgba(250,247,242,0.92)',
        border: '1px solid rgba(61,50,41,0.08)',
        boxShadow: '0 4px 24px rgba(61,50,41,0.08), 0 1px 4px rgba(61,50,41,0.04)'
      }} data-id="element-557">
            <div className="w-8 h-8 rounded-full bg-sage/15 flex items-center justify-center shrink-0" data-id="element-558">
              <ShoppingBag className="w-3.5 h-3.5 text-sage" data-id="element-559" />
            </div>
            <div className="min-w-0" data-id="element-560">
              <p className="text-brown text-[13px] font-medium leading-tight truncate" data-id="element-561">
                {buyer.name}{' '}
                <span className="text-brown/50 font-normal" data-id="element-562">
                  from {buyer.location}
                </span>
              </p>
              <p className="text-brown/40 text-[11px] mt-0.5" data-id="element-563">
                Just purchased · {buyer.time}
              </p>
            </div>
          </div>
        </motion.div>}
    </AnimatePresence>;
}